import { useEffect } from 'react';

/** Convenience hook for Telegram WebApp methods. */
export function useTelegram() {
  const tg = window.Telegram?.WebApp;
  return {
    tg,
    user: tg?.initDataUnsafe?.user,
    /**
     * `start_param` is the value after `?startapp=` when the user lands on
     * the Mini App via a deep-link (e.g. compatibility invites).
     * Format we use: `compat_<UUID>`.
     */
    startParam: tg?.initDataUnsafe?.start_param,
    haptic: tg?.HapticFeedback,
    openInvoice: (link: string, cb: (status: string) => void) =>
      tg?.openInvoice(link, cb),
  };
}

/** Parse `compat_<uuid>` deep-links. Returns the invite id, or null. */
export function parseCompatInvite(startParam: string | undefined): string | null {
  if (!startParam) return null;
  const m = /^compat_([0-9a-fA-F-]{36})$/.exec(startParam);
  return m ? m[1] : null;
}

/** Parse `ref_<telegram_id>` deep-links. Returns the inviter's id, or null. */
export function parseReferrerId(startParam: string | undefined): number | null {
  if (!startParam) return null;
  const m = /^ref_(\d{1,20})$/.exec(startParam);
  return m ? Number(m[1]) : null;
}

/** Run a side-effect when the colour scheme (light/dark) changes. */
export function useTelegramThemeSync(onChange: (scheme: 'light' | 'dark') => void) {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;
    onChange(tg.colorScheme);
  }, [onChange]);
}
